"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFailedException = void 0;
const http_exception_1 = require("./http.exception");
class PaymentFailedException extends http_exception_1.HttpException {
    constructor(reason) {
        super(501, `Payment failed with reason: ${reason}`);
    }
}
exports.PaymentFailedException = PaymentFailedException;
//# sourceMappingURL=paymentFailed.exception.js.map